import { Message } from 'element-ui';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { messagePage } from '@/api/message.js'
Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({

    /* vuex数据持久化配置 */
    plugins: [
        createPersistedState({
            // 存储方式：localStorage、sessionStorage、cookies
            storage: window.localStorage,
            // 存储的 key 的key值
            key: "store",
            render (state) {
                // 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
                return { ...state };
            }
        })
    ],
    state: {
        institution: '中国航油集团重庆石油有限公司',
        user: false,
        loading: false,
        importLoading: false,
        userInfo: {},
        logintoken: '',
        registerButtonList: [],//  权限按钮
        currentRoleItem: {}, // 当前角色
        menuList: [],
        messageList: [],
        isReadNum: 0,
        websocketClient:null,
        progress:-1,
    },
    mutations: {
        // 登录
        login (state, user) {
            state.user = user;
            localStorage.setItem("user", user);
        },
        // 退出
        logout (state, user) {
            state.user = "";
            state.logintoken = "";
            state.userInfo = {};
            state.registerButtonList = [];
            localStorage.setItem("user", "");
            localStorage.removeItem("logintoken");
        },
        setUserInfo (state, userInfo) {
            state.userInfo = userInfo;
        },
        setButtonList (state, registerButtonList) {
            state.registerButtonList = registerButtonList;
        },
        setMenuList (state, menuList) {
            state.menuList = menuList;
        },
        setToken (state, token) {
            state.logintoken = token;
        },
        getMessageIsReadNum: state => {
            const pararms = {
                isRead: false,
                pageNum: 1,
                pageSize: 2,
            };
            messagePage(pararms).then(res => {
                if (res.code == 200) {
                    state.messageList = res.data.records;
                    state.isReadNum = res.data.total
                }
            })
        }
    },
    getters: {
        getFirstPage: state => {
            let fistMenu = state.registerButtonList.find(item => (item.routingAddress && item.type != 'BUTTON' && item.routingAddress != '/'));
            if (fistMenu) {
                return fistMenu.routingAddress
            } else {
                Message.error('该用户角色无权限')
                state.user = '';
                localStorage.setItem("user", "");
                localStorage.removeItem("logintoken");
                return '/login'
            }
        },

    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js